import Vue from "vue";
import appVue from "@/main.js";
import OverlayBase from "./OverlayBase.vue";

export class OverlayManager {
  static overlayBase = null;
  static overlayDom = null;
  static modals = [];

  static doShowOverlay() {
    return this.modals.length === 0;
  }

  static getOverlayDom() {
    return this.overlayDom ?? this.loadOverlay();
  }

  static getOverlayBase() {
    return this.overlayBase ?? (this.loadOverlay() && this.overlayBase);
  }

  static getModal(name) {
    return this.modals[name];
  }

  static getTopModal() {
    if (this.modals.length === 0) return;
    return this.modals[this.modals.length - 1];
  }
  static delayRemove(visible) {
    setTimeout(() => { 
      this.getOverlayBase().setVisibility(visible);
    }, 2000);
  }

  static handleOverlayClick() {
    this.getTopModal()?.handleOverlayClick();
  }

  static loadOverlay() {
    let olbase = Vue.extend(OverlayBase);
    this.overlayBase = new olbase({
      parent: appVue,
    });
    let mountPoint = document.getElementById("overlay-mount");
    this.overlayBase.$mount();
    this.overlayDom = this.overlayBase.$el;
    mountPoint.appendChild(this.overlayDom);
    this.overlayDom.addEventListener("touchmove", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    this.overlayDom.addEventListener("click", () => {
      this.handleOverlayClick();
    });

    // handle `esc` key when the popup is shown
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        this.getTopModal()?.handleEscapePress();
      }
    });
    return this.overlayDom;
  }

  static register(modal) {
    if (modal) {
      // Hide old modal if exists
      if (this.modals.length > 0) {
        this.getOverlayDom().children.item(0).remove();
      }
      // Add new modal and show
      this.modals.push(modal);
      this.getOverlayDom().appendChild(modal.$el);
      this.getOverlayBase().setVisibility(true);
      return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    }
  }

  static deregister(id) {
    if (id != null) {

      let index = this.modals.findIndex(m => m.id == id);
      this.modals[index] = null;
      this.modals.splice(index, 1);
      return index;
    }
  }

  static close(id) {
    if (this.modals.length === 0) return;
    let deregIndex = this.deregister(id);
    // If index was top, meaning visible, then remove.
    if (deregIndex == this.modals.length)
      this.getOverlayDom().children.item(0).remove();

    if (this.modals.length > 0) {
      this.getOverlayDom().appendChild(this.modals[this.modals.length - 1].$el);
      this.getOverlayBase().setVisibility(true);
    } else {
      this.getOverlayBase().setVisibility(false);
    }
  }
  static closeAll() {
    if (this.modals.length === 0) return;
    let m = null;
    do {
      m = this.modals.pop();
      m?.close();
    } while (m);
    while (this.getOverlayDom().children.length > 0) {
      this.getOverlayDom().children.item(0).remove();
    }
    this.getOverlayBase().setVisibility(false);
  }
}
